import React from 'react';
import { NavLink } from 'react-router-dom';
const Uganda1_university_subjects = () => {
  return (
    <div className='fixed top-16 right-0 left-0 h-7 justify-items-stretch w-full content-center gap-4 overflow-x-scroll whitespace-nowrap scroll-smooth flex scrollbar-hide bg-cyan-400 items-center z-50 justify-evenly'>
      
      <NavLink to="/tutoring/learner/uganda1/uganda1_university/uganda1_university_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Algebra</NavLink>     
      
      <NavLink to="/tutoring/learner/uganda1/uganda1_university/uganda1_university_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Business Administration</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_university/uganda1_university_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Calculus</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_university/uganda1_university_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Commerce</NavLink>   

       <NavLink to="/tutoring/learner/uganda1/uganda1_university/uganda1_university_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Computer Science</NavLink>     
      
      <NavLink to="/tutoring/learner/uganda1/uganda1_university/uganda1_university_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Economics</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_university/uganda1_university_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Education</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_university/uganda1_university_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Engineering</NavLink>      

       <NavLink to="/tutoring/learner/uganda1/uganda1_university/uganda1_university_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Nursing</NavLink>     
      
      <NavLink to="/tutoring/learner/uganda1/uganda1_university/uganda1_university_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Pharmacy</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_university/uganda1_university_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md'
        }
      >Psychology</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_university/uganda1_university_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Statistics</NavLink> 

       <NavLink to="/tutoring/learner/uganda1/uganda1_university/uganda1_university_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Medicine</NavLink>     
      
      <NavLink to="/tutoring/learner/uganda1/uganda1_university/uganda1_university_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Agriculture</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_university/uganda1_university_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Geography</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_university/uganda1_university_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Public Health</NavLink> 
        
    </div>
  );
}

export default Uganda1_university_subjects;